
import React from 'react';
import CompactLayout from '@/components/layout/CompactLayout';
import SustainabilityDashboard from '@/components/sustainability/SustainabilityDashboard';

const SustainabilityDashboardPage = () => {
  return (
    <CompactLayout>
      <SustainabilityDashboard />
    </CompactLayout>
  );
};

export default SustainabilityDashboardPage;
